export type DeviceFormReferrerKind = 'revision' | 'form';

export interface DeviceFormReferrer {
  kind: DeviceFormReferrerKind;
  revisionId: string;
  returnTo: string;
}

export interface DeviceFormLocationState {
  deviceFormReferrer?: DeviceFormReferrer;
}

/**
 * Creates location state for navigating to the device form from another form.
 */
export function createDeviceFormReferrerState(referrer: DeviceFormReferrer): DeviceFormLocationState {
  return { deviceFormReferrer: referrer };
}

/**
 * Reads and validates the device form referrer from React Router location state.
 */
export function getDeviceFormReferrer(state: unknown): DeviceFormReferrer | undefined {
  const referrer = (state as DeviceFormLocationState | null)?.deviceFormReferrer;

  if (!referrer) {
    return undefined;
  }

  if (referrer.kind !== 'revision' && referrer.kind !== 'form') {
    return undefined;
  }

  if (typeof referrer.revisionId !== 'string' || typeof referrer.returnTo !== 'string') {
    return undefined;
  }

  return referrer;
}
